/**
 * Legacy public barrel (package.json "browser"). Not a Vite entry.
 *
 * The imports below are static, so anything taken from here also pulls in
 * Extendable + CookieConsent (cash-dom) and Suggestions + InputTags (React).
 * Every consumer takes only `{Element}` / `{WpMediaLibrary}`, so those four are
 * bundled dead weight — import lib/Element.js and lib/WpMediaLibrary.js direct.
 *
 * No runtime warning here on purpose: a module-scope warn would fire for every
 * consumer on a legitimate `{Element}` import, and wrapping `Application` to
 * warn lazily would split its static state.
 *
 * @deprecated use lib/XlibApplication.js + lib/XlibElement.js
 *   (docs/element-js-conventions.md) instead of the re-exported Application and
 *   Element; import WpMediaLibrary from lib/WpMediaLibrary.js.
 * @see Consumers 2026-08-06: web-plus-computerwissen, web-reichweiten,
 *   wp-cosi, wp-epaper, wp-premium, wp-vnr-praemien-shop. Removable when this
 *   list is empty.
 */
import Element from './lib/Element';
import ElementExtendable from './elements/Extendable';
import CookieConsent from './elements/CookieConsent';
import SuggestionsModule from './elements/Suggestions';
import InputTagsModule from './elements/InputTags';
import Application from './lib/Application';
import WpMediaLibrary from './lib/WpMediaLibrary.js';

export {
    Element,
    ElementExtendable,
    CookieConsent,
    SuggestionsModule as Suggestions,
    InputTagsModule as InputTags,
    Application,
    WpMediaLibrary,
};
